<template>
  <body id="secondaryBody" :style="{ backgroundColor: inisVl }">
    <div
      style="
        overflow-x: hidden;
        overflow-y: hidden;
        padding-right: 0px;
        padding-left: 0px;
      "
      id="app"
      class="container"
    >
      <nav-bar></nav-bar>
      <router-view></router-view>
      <Footer></Footer>
    </div>
  </body>
</template>

<script>
import Inis from "./services/inis";
import Footer from "./components/Footer.vue";
import NavBar from "./components/NavBar.vue";

export default {
  name: "app",
  components: {
    NavBar,
    Footer,
  },
  data() {
    return {
      inisVl: "",
    };
  },
  methods: {
    alterarTitle() {
      var cd = "ESTABELECIMENTO";
      Inis.listarInisCd(cd).then((resposta) => {
        const name = resposta.data[0].vl + " - Pantera Deli";
        document.title = name;
      });
    },
    listandoInis() {
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.inisVl = resposta.data[0].vl;
      });
    },
  },
  mounted() {
    localStorage.setItem("contrato", "5453");
    this.alterarTitle();
    this.listandoInis();
  },
};
</script>
